import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoVelocityFolderM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.2452 3C3.59385 3 3.90636 3.21511 4.03084 3.54078L6.91477 11.0859C6.92827 11.1212 6.96218 11.1445 7 11.1445C7.03782 11.1445 7.07173 11.1212 7.08523 11.0859L9.96916 3.54078C10.0936 3.21511 10.4061 3 10.7548 3C11.3506 3 11.7575 3.60242 11.535 4.15513L8.22709 12.3734C8.0747 12.752 7.70754 13 7.29942 13H6.70058C6.29246 13 5.9253 12.752 5.77291 12.3734L2.46496 4.15513C2.24248 3.60242 2.64939 3 3.2452 3Z"
        fill="var(--color-typo-primary)"
      />
      <path
        d="M13.9078 8.14682V9.0194H11V8.14682H13.9078ZM11.7179 7H12.91V11.4938C12.91 11.6454 12.9341 11.7618 12.9824 11.8428C13.0329 11.9218 13.0988 11.9758 13.18 12.0049C13.2613 12.034 13.3513 12.0485 13.4501 12.0485C13.5247 12.0485 13.5928 12.0433 13.6542 12.0329C13.7179 12.0225 13.7662 12.0132 13.7991 12.0049L14 12.8868C13.9363 12.9076 13.8452 12.9304 13.7267 12.9554C13.6103 12.9803 13.4676 12.9948 13.2986 12.999C13 13.0073 12.7311 12.9647 12.4918 12.8712C12.2525 12.7756 12.0626 12.6281 11.9221 12.4287C11.7838 12.2292 11.7157 11.9799 11.7179 11.6808V7Z"
        fill="var(--color-typo-primary)"
      />
    </svg>
  )
}

export const IconGeoVelocityFolder = createIcon({
  l: IconGeoVelocityFolderM,
  m: IconGeoVelocityFolderM,
  s: IconGeoVelocityFolderM,
  xs: IconGeoVelocityFolderM,
  name: 'IconGeoVelocityFolder',
})
